/**
 * File view.js
 */
(function ($) {
    "use strict";

    $(document).ready(function () {
        const heights = $(".content-listing__icon-style .button-block-a__item .button-block-a__inner-text").map(function() {
            return $(this).outerHeight(true);
        }).get();
        
        const maxHeight = Math.max.apply(null, heights);
        $(".content-listing__icon-style .button-block-a__item .button-block-a__inner-text").css("height", maxHeight);
    });
    $(window).on('resize', function () {
        const heights = $(".content-listing__icon-style .button-block-a__item .button-block-a__inner-text").map(function() {
            return $(this).outerHeight(true);
        }).get();
        
        const maxHeight = Math.max.apply(null, heights);
        $(".content-listing__icon-style .button-block-a__item .button-block-a__inner-text").css("height", maxHeight);
    });
})(jQuery);
  